const recetasDigitalesInitialState = {
  recetasDigitales: {
    loading: false,
    error: null,
    data: null,
    receta: {
      dni: "",
      nombre: "",
      telefono: "",
      seAtendio: "",
      horario: "",
      nombreMedico: "",
      farmacia: "",
      // nombreFarmaceutico: "",
      // numMatriculaFarmaceutico: "",
    },
    listErrorReceta: {
      dni: false,
      nombre: false,
      telefono: false,
      seAtendio: false,
      horario: false,
      nombreMedico: false,
      farmacia: false,
      // nombreFarmaceutico: false,
      // numMatriculaFarmaceutico: false,
    },
  },
};

export default recetasDigitalesInitialState;
